import { IAppState } from '../../common/state';

export function selectNewbuildingFlightEntryUrl(state: IAppState) {
  return state.featureToggle.newbuildingFlightEntryUrl;
}
